import React from 'react';
import { motion } from 'framer-motion'; // Import de Framer Motion
import '../Style/PeriodicTable.css';

const PeriodicTable = () => {
  return (
    <div className="periodic-table-container">
      <a href="https://ptable.com/" target="_blank" rel="noopener noreferrer">
        <motion.img
          src="/images/PeriodicTable.png"
          alt="Tableau périodique"
          className="periodic-table-image"
          initial={{ opacity: 0, scale: 0.8 }} // État initial (invisible et réduit)
          animate={{ opacity: 1, scale: 1 }} // État final (visible et à taille normale)
          transition={{ duration: 0.8, ease: 'easeOut' }} // Durée et effet de transition
          whileHover={{ scale: 1.05 }} // Zoom léger au survol
        />
      </a>
    </div>
  );
};

export default PeriodicTable;
